// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResults_container__ITaSA"};